export default __webpack_public_path__ + "static/media/icon-login-input-close.8945d150.svg";